import customAxios from "../index";
import qs from "qs";

export interface SupportRequestPayload {
  name: string;
  contactEmail: string;
  contactNumber?: string;
  countryCode?: string;
  subject: string;
  detailedDescription: string;
  attachment?: File;
  //partnerId: string | number;
}

export interface SupportTicket {
  id: number;
  name: string;
  ticket_id: string;
  subject: string;
  created_at: string;
  ticketId?: string;
  raisedBy?: string;
  dateSubmitted?: string;
  contactEmail?: string;
  detailedDescription?: string;
  attachmentUrl?: string;
  status?: string;
}

export interface SupportRequestResponse {
  success: boolean;
  data: {
    message: string;
    ticketId?: string;
  };
}

export interface SupportHistoryResponse {
  success: boolean;
  data: {
    message: string;
    data: SupportTicket[];
  };
}

export const submitSupportRequest = (data: FormData) => {
  return customAxios({
    method: "POST",
    url: "/provider-dashboard/communication-support",
    data,
  });
};

export const getSupportHistory = (params?: {
  page?: number;
  pageSize?: number;
}) => {
  return customAxios({
    method: "GET",
    url: "provider-dashboard/communication-support",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};


export const getSupportTicketDetails = (ticketId: string | number) => {
  return customAxios({
    method: "GET",
    url: `/provider-dashboard/communication-support/${ticketId}`,
  });
};






